import React from "react";
import Routes from "./Routes/Routes";
import "./_overrides.scss";
import Analytics from "./components/Analytics";
import ReactGA from "react-ga4";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
